import { createFileRoute } from '@tanstack/react-router'
import { mockInterviewSearchSchema } from './-mock-interview-search'

export const Route = createFileRoute('/$locale/dashboard/mock-interview')({
  validateSearch: mockInterviewSearchSchema,
})
